<template>
  <div>
    {{$props.message}}
  </div>
</template>

<script>

export default {
  name:'Info',
  components: {
  },
  props: {
    message: String
  },
  data () {
    return {
    };
  }
}
</script>
<style>

</style>